// extracted by mini-css-extract-plugin
module.exports = {"L":"2440","M":"1024","S":"768","XS":"576"};